@if (_isDicInfoLoading) {
  <div class="elem-skeletons square-divs" style="display: flex">
    <ddc-loading-skeleton></ddc-loading-skeleton>
  </div>
} @else {
  <div class="base-cont">
    <!-- ! Header -->
    <div class="dictionary-profile-container">
      <mat-card class="dictionary-info-card">
        <!-- Row 1: Profile pic and Edit button -->
        <div class="dictionary-header">
          <ddc-profile-pic
            class="dic-card-owner"
            [creationTime]="_dic?.time_since_creation"
            [dynamicRoute]="'/users/' + _dic?.owner?.username"
            [followerCount]="_dic?.owner?.followers_count"
            [subscription]="_dic?.owner?.subscription"
            [username]="_dic?.owner?.username"
            [userProfilePic]="_dic?.owner?.profile_pic"
          ></ddc-profile-pic>

          @if (_isMine) {
            <div style="display: flex; gap: 20px">
              <ddc-icon-function
                [icon]="'edit'"
                [tooltip]="'Edit Dictionary'"
                (click)="openEditDictionaryDialog()"
              ></ddc-icon-function>
              <ddc-icon-function
                [icon]="'delete'"
                [tooltip]="'Delete Dictionary'"
                (click)="openDeleteDictionaryDialog()"
              ></ddc-icon-function>
            </div>
          }
        </div>

        <!-- Row 2: Title and expandable description -->
        <div class="dictionary-content">
          <div class="counts-container">
            <ddc-element-count
              class="dic-counts-elem"
              matTooltip="Words"
              [count]="_dicWordsNStr"
              [icon]="'fiber_manual_record'"
              [size]="'small'"
            ></ddc-element-count>
            <ddc-element-count
              class="dic-counts-elem"
              matTooltip="Pairs"
              [count]="_dicPairsNStr"
              [icon]="'fiber_smart_record'"
              [size]="'small'"
            ></ddc-element-count>
          </div>
          <h2 class="dictionary-title">{{ _dicTitle }}</h2>
          <div class="expandable-description">
            <p class="dictionary-description" [class.expanded]="_isDescriptionExpanded">{{ _dicDescription }}</p>
            @if (_dicDescription?.length > 100) {
              <button class="expand-btn" mat-button (click)="_isDescriptionExpanded = !_isDescriptionExpanded">
                {{ _isDescriptionExpanded ? 'Show less' : 'Show more' }}
              </button>
            }
          </div>
        </div>

        <!-- Row 3: Stats, likes and bookmarks -->
        <div class="dictionary-stats">
          <ddc-button-n-two
            class="navbar_create_btn"
            *ngIf="_isMine"
            [_icon]="'auto_stories'"
            [_label]="'Import To Dictionary'"
            (click)="onImportToDicClicked()"
          ></ddc-button-n-two>
          <div class="social-actions">
            <ddc-like
              [content_type_id]="contentTypeID"
              [count]="_dic.likes"
              [is_liked]="_dicIsLiked"
              [obj_id]="_dic.id"
              [type]="_dic_c_type"
            >
            </ddc-like>
            <ddc-bookmark
              [bookmarks]="_dicBookmarksN"
              [content_type_id]="contentTypeID"
              [element]="_dicElement"
              [is_bookmarked]="_dicIsBookmarked"
              [obj_id]="_dic.id"
              [type]="_dic_c_type"
            >
            </ddc-bookmark>
          </div>
        </div>
      </mat-card>
    </div>

    <!-- ! Tabs -->
    <div class="dictionary-tabs-container">
      <div class="tabs-button-row">
        <ddc-tabs-chips
          [tabs]="[
            { key: 'words', label: 'Words', icon: 'fiber_manual_record', selected: _isWordsSelected },
            { key: 'pairs', label: 'Pairs', icon: 'fiber_smart_record', selected: _isPairsSelected },
          ]"
          [theme]="_isLightTheme ? 'light' : _isDarkTheme ? 'dark' : 'paper'"
          (tabClick)="clickedChip($event)"
        ></ddc-tabs-chips>
      </div>
    </div>

    <div class="dictionary-content-container">
      <!-- ! Words -->
      @if (_isWordsSelected) {
        <div class="lib-words-container">
          @if (!_isWordsLoading) {
            <div class="words-content">
              <div class="word-content-main">
                @if (_words?.length > 0) {
                  <div
                    infiniteScroll
                    [infiniteScrollDistance]="1"
                    [infiniteScrollThrottle]="500"
                    (scrolled)="onWordsScroll()"
                  >
                    <div *ngFor="let word of _words; let i = index" style="margin: 10px">
                      <ddc-content-card
                        [content]="word"
                        (clicked)="openReadWordDialog(i)"
                        (deleteClicked)="openDeleteWordDialog(i)"
                        (editClicked)="openEditWordDialog(i)"
                      ></ddc-content-card>
                    </div>
                  </div>
                }
                <!-- Info at bottom -->
                <div class="word-info-label" *ngIf="_words?.length > 0">
                  <ng-lottie
                    *ngIf="!_wordsEnd && !_wordsScrollLoading"
                    width="30px"
                    [options]="scroll_options"
                  ></ng-lottie>
                  <ng-lottie *ngIf="_wordsScrollLoading" width="50px" [options]="loading_options"></ng-lottie>
                  <mat-icon *ngIf="_wordsEnd && !_wordsScrollLoading">fact_check</mat-icon>&nbsp;&nbsp;{{
                    _wordsPageInfoLabel
                  }}
                </div>
                @if (_words.length === 0 && !_isWordsLoading && _isWordsLoaded) {
                  <ddc-not-available [_elem]="'Word'"></ddc-not-available>
                }
              </div>
            </div>
          }
          @if (_isWordsLoading) {
            <div class="word-skeletons elem-skeletons" style="display: flex">
              <ddc-loading-skeleton></ddc-loading-skeleton>
            </div>
          }
        </div>
      }

      <!-- ! Pairs -->
      @if (_isPairsSelected) {
        <div class="lib-pairs-container">
          @if (!_isPairsLoading) {
            <div class="pairs-content">
              <div class="pair-content-main">
                @if (_pairs?.length > 0) {
                  <div
                    infiniteScroll
                    [infiniteScrollDistance]="1"
                    [infiniteScrollThrottle]="500"
                    (scrolled)="onPairsScroll()"
                  >
                    <div *ngFor="let pair of _pairs; let i = index" style="margin: 10px">
                      <ddc-content-card
                        [content]="pair"
                        (clicked)="openReadPairDialog(i)"
                        (deleteClicked)="openDeletePairDialog(i)"
                        (editClicked)="openEditPairDialog(i)"
                      ></ddc-content-card>
                    </div>
                  </div>
                }
                <!-- Info at bottom -->
                <div class="pair-info-label" *ngIf="_pairs?.length > 0">
                  <ng-lottie
                    *ngIf="!_pairsEnd && !_pairsScrollLoading"
                    width="30px"
                    [options]="scroll_options"
                  ></ng-lottie>
                  <ng-lottie *ngIf="_pairsScrollLoading" width="50px" [options]="loading_options"></ng-lottie>
                  <mat-icon *ngIf="_pairsEnd && !_pairsScrollLoading">fact_check</mat-icon>&nbsp;&nbsp;{{
                    _pairsPageInfoLabel
                  }}
                </div>
                @if (_pairs.length === 0 && !_isPairsLoading && _isPairsLoaded) {
                  <ddc-not-available [_elem]="'Pair'"></ddc-not-available>
                }
              </div>
            </div>
          }
          @if (_isPairsLoading) {
            <div class="pair-skeletons elem-skeletons" style="display: flex">
              <ddc-loading-skeleton></ddc-loading-skeleton>
            </div>
          }
        </div>
      }
    </div>
  </div>
}
